import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-avatar inline-flex align-items-center justify-content-center text-white text-lg font-bold mr-2 cursor-pointer" }
const _hoisted_2 = { class: "flex-grow-1" }
const _hoisted_3 = { class: "flex justify-content-between justify-content-start mb-1" }
const _hoisted_4 = { class: "flex justify-content-between" }
const _hoisted_5 = { class: "max-w-7rem overflow-hidden text-dark text-overflow-ellipsis white-space-nowrap" }
const _hoisted_6 = { class: "flex align-content-center" }
const _hoisted_7 = { class: "text-sm" }

import { computed, ref, toRefs } from 'vue';
import { useMessageCenterStore } from '@/store';
import ConfirmAction from '@/components/ConfirmAction';
import DisplayChatName from './../../DisplayChatName';
import { can, useDateTime } from '@/composables';
import { PERMISSIONS } from '@/enum';

interface PropsInterface {
  id: number;
  name: string;
  lastMessage?: string;
  unreadCount: number;
  updatedAt: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatThread',
  props: {
    id: {},
    name: {},
    lastMessage: {},
    unreadCount: {},
    updatedAt: {}
  },
  setup(__props: any) {

const messageCenter = useMessageCenterStore();

const props = __props;
const { id, name, lastMessage, unreadCount, updatedAt } = toRefs(props);
const toggleDeleteConversation = ref(false);

const onOpenChat = () => {
  if (can([PERMISSIONS.CHAT_SHOW])) messageCenter.setActiveChat(id.value);
};

const onRemoveChat = () => {
  messageCenter.deleteChat(id.value);
};

const getChatAvatar = () => {
  const words = name.value.trim().split(/\s+/);
  const initials = words.map((word) => word[0].toUpperCase()).join('');
  return initials.length > 2 ? initials.slice(0, 2) : initials;
};

const menuItems = [
  {
    label: 'Delete Conversation',
    command: () => {
      toggleDeleteConversation.value = true;
    },
    visible: can([PERMISSIONS.CHAT_DESTROY]),
  },
];

const showMenuItems = computed(() => {
  return menuItems.filter((menu) => menu.visible === true).length > 0;
});

return (_ctx: any,_cache: any) => {
  const _component_ActionMenu = _resolveComponent("ActionMenu")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "surface-100 border-round-lg flex justify-content-between align-items-center my-2 p-2 w-full transition-duration-100 cursor-pointer hover:surface-50",
      onClick: onOpenChat
    }, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(getChatAvatar()), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(DisplayChatName), {
            name: _unref(name),
            class: "text-sm max-w-12rem"
          }, null, 8, ["name"]),
          (showMenuItems.value)
            ? (_openBlock(), _createBlock(_component_ActionMenu, {
                key: 0,
                "menu-items": menuItems,
                icon: "more_horiz",
                class: "text-dark-medium h-1rem flex align-items-center"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(lastMessage)), 1),
          _createElementVNode("div", _hoisted_6, [
            (_unref(unreadCount) > 0)
              ? (_openBlock(), _createBlock(_component_Icon, {
                  key: 0,
                  name: "circle",
                  class: "material-icons text-teal-300 text-sm unread-icon"
                }))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(useDateTime)().formatDateTimeForMessageFromUTC(_unref(updatedAt))), 1)
          ])
        ])
      ])
    ]),
    (toggleDeleteConversation.value && _unref(can)([_unref(PERMISSIONS).CHAT_DESTROY]))
      ? (_openBlock(), _createBlock(_unref(ConfirmAction), {
          key: 0,
          header: "Delete Conversation",
          "accept-label": "Yes",
          "reject-label": "No",
          onAccept: _cache[0] || (_cache[0] = ($event: any) => (onRemoveChat())),
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (toggleDeleteConversation.value = false))
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createElementVNode("div", null, "Are you sure want to delete this conversation?", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})